
import { TabView, TabPanel } from 'primereact/tabview';
import { BasicInfo } from './components/BasicInfo';
import { Abandoned } from './components/Abandoned';
import { Use } from './components/Use';
import { Transportation } from './components/Transportation';
import { Manufacture } from './components/Manufacture';
import { Materials } from './components/Materials';


export default function ProductCarbonFootprint_Index() {
    return (
        <>
            <div className="p-card bg-gray">
                <div className="p-card-body">
                    <span>昕力資訊</span>
                </div>
            </div>

            <div className="p-card">
                <div className="p-card-body">
                    <TabView>
                        <TabPanel header="基本資料">
                            <BasicInfo></BasicInfo>
                        </TabPanel>
                        <TabPanel header="原料取得階段">
                            <Materials></Materials>
                        </TabPanel>
                        <TabPanel header="製造階段">
                            <Manufacture></Manufacture>
                        </TabPanel>
                        <TabPanel header="配銷(運輸)階段">
                            <Transportation></Transportation>
                        </TabPanel>
                        <TabPanel header="使用階段">
                           <Use></Use>
                        </TabPanel>
                        <TabPanel header="廢棄階段">
                        <Abandoned></Abandoned>
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        </>
    )
}
